export default __webpack_public_path__ + "static/media/imageTwo.fd60400e.png";